import styles from "./AccentMarks.module.scss";

export default function AccentMarks({className = "", ...rest}) {
  return (
    <div data-testid="accent-marks-container" className={`${styles.container} ${className}`} {...rest}>
      <span data-testid="accent-mark" className={`${styles.mark}`}></span>
      <span data-testid="accent-mark" className={`${styles.mark}`}></span>
      <span data-testid="accent-mark" className={`${styles.mark}`}></span>
    </div>
  );
}
